module.exports = __webpack_public_path__ + "static/media/dolly-empty.47123160.svg";